<template>
    <div id="components-main-layout" v-if="check">
        <a-layout :style="{ zIndex: 1, height: '100%' }">
            <menu_sidebar>这里是sidebar</menu_sidebar>
            <a-layout :style="{ zIndex: 2 }">
                <header_bar>这里是header</header_bar>
                <a-layout-content :style="{padding:'0 20px'}">
                    <div>
                        <a-row :style="{marginTop:'10px',}">
                            <a-breadcrumb>
                                <a-breadcrumb-item>借款/报销单</a-breadcrumb-item>
                                <a-breadcrumb-item>列表</a-breadcrumb-item>
                            </a-breadcrumb>
                        </a-row>
                        <a-row>
                            <div style="background:#FFFFFF;width:100%;margin-top:10px;border-top:4px solid #CCCCCC;padding:10px;">
                                <a-row  :style="{margin:'15px 0 15px 0'}">
                                    <a-col :span="12" align="left"><span style="font-size:18px;">借款/报销单列表</span></a-col>
                                    <a-col :span="12" align="right">
                                        <a-button type="primary" size="default"><router-link to="/bogus_op">添加借款/报销单</router-link></a-button>
                                    </a-col>
                                </a-row>
                                <a-row>
                                    <a-table
                                        :columns="columns"
                                        :data-source="data"
                                        bordered
                                        :pagination="pagination"
                                        :loading="loading"
                                        row-key="id"
                                        @change="PageChange"
                                    >
                                        <span slot="operator" slot-scope="id,record">
                                            <router-link target="_blank" :to="{path:'pdf.php',query:{id:token+record.id}}" style="margin-right:10px;">打印</router-link>
                                            <router-link :to="{name:'bogus_detail',params:{id:record.id}}" style="margin-right:10px;">详情</router-link>
                                            <router-link :to="{name:'bogus_op',params:{id:record.id}}">编辑</router-link>
                                        </span>
                                    </a-table>
                                </a-row>
                            </div>
                        </a-row>
                    </div>
                </a-layout-content>
                <footer_bar>这里是footer</footer_bar>
            </a-layout>
        </a-layout>
    </div>
</template>

<script>
import menu_sidebar from '../components/menu_sidebar'
import header_bar from '../components/header'
import footer_bar from '../components/footer'
import axios from 'axios'
import Cookies from "js-cookie";

const columns = [
    {
        title: 'ID',
        dataIndex: 'id',
        width:70,
        align:'center',
    },
    {
        title: '费用编号',
        dataIndex: 'pre_NO',
        width:120,

    },
    {
        title: '公司名称',
        dataIndex: 'company',
    },
    {
        title: '币种',
        dataIndex: 'currency',
        width:70,
        align:'center',
    },
    {
        title: '金额',
        dataIndex: 'money',
        width:100,
        align:'right',
    },
    {
        title: '创建时间',
        dataIndex: 'date',
        ellipsis: true,
        width:120,
        align:'center',
    },
    {
        title: '操作',
        dataIndex: 'operators',
        ellipsis: true,
        width:140,
        align:'center',
        scopedSlots:{customRender:'operator'},
    },
];


export default {
    name: "Home",
    components:{
        menu_sidebar,
        header_bar,
        footer_bar,
    },
    data(){
        return {
            data:[],
            columns,
            current: ['21'],
            openKeys: ['2'],
            pagination: {
                total:0,
                defaultPageSize:10,
                size:'small',
            },
            token:0,
            loading: false,
            check:false,
            json_data:{
                'action':'bogus',
                'type':'DETAIL',
                'page':1,
            }
        };
    },
    mounted() {
        this.fetch();
    },
    beforeMount() {
        var token = Cookies.get('Token');
        this.token = token;
        var json_data = '{"action":"CheckToken","token":"'+token+'"}';
        let self = this;
        axios.post('/api/index.php',json_data)
            .then((response)=> {
                if(response.data.status!=1){
                    self.$router.push({path:'/login'})
                }else{
                    this.check = true;
                }
            })
            .catch(function (error) { // 请求失败处理
                console.log(error);
            });
        this.$store.commit("sidebar_current", ['23'])
        this.$store.commit("sidebar_openKeys", ['2'])
    },
    computed:{

    },
    methods:{
        PageChange(pagination) {
            this.fetch(pagination.current)
        },
        fetch(page){
            this.json_data.token = Cookies.get('Token');
            this.loading = true;
            this.json_data.page = page;
            axios.post("/api/index.php",this.json_data).then(response => {
                if (response.data) {
                    if(response.data.status == 1 && response.data.total !=='') {
                        this.loading = false;
                        this.pagination.total = response.data.total
                        this.data = response.data.data
                    }
                }
            })
        },
    }
}
</script>

<style scoped>
#components-main-layout{height:100%;width:100%;}
#components-main-layout {
    /*text-align: center;*/
}

#components-main-layout .ant-layout-sider {
    background: #E9EEF3;
    color: #fff;
}
#components-main-layout .ant-layout-content {
    /*background: #E9EEF3;*/
    color: #666666;
}
#components-main-layout > .ant-layout {
    margin-bottom: 48px;
}
#components-main-layout > .ant-layout:last-child {
    margin: 0;
}
</style>